import states from "./states"
import { VA_UPDATE_STATE, VA_CREATED, VA_UPDATION } from "./actiontypes"

const voice_agents_details = (state = states.voice_agents_details, action) => {
  switch (action.type) {
    case VA_UPDATE_STATE:
      return action.stateKey
        ? {
            ...state,
            [action.stateKey]: {
              ...state[action.stateKey],
              ...action.payload,
            },
          }
        : {
            ...state,
            ...action.payload,
          }

    case VA_UPDATION: {
      const {
        voiceagents = [],
        total = 0,
        reset = false,
      } = action.payload || {}
      return {
        ...state,
        records: reset
          ? voiceagents
          : [...(state.records || []), ...voiceagents],
        totalVoiceAgents: total,
        loading: false,
        loadError: false,
      }
    }

    case VA_CREATED:
      return {
        ...state,
        records: [action.payload, ...state.records],
      }

    default:
      return state
  }
}
export default voice_agents_details
